import { selectIsOfferRedesign } from 'shared/selectors/abExperiments';

import { IState } from '../store';

export const selectIsOfferPageRedesign = (state: IState) => {
  const isRedesignABActive = selectIsOfferRedesign(state);

  return isRedesignABActive;
};
